import React, { Component } from 'react'
import Select from 'renanol-select'
import request from './../../utils/requestConfig'
import Scrollbars from 'react-custom-scrollbars'
import { truncate, isEmpty } from 'lodash'

const menuRenderer = (params) => {
  // use default renderer in a hacky way
  const menu = Select.defaultProps.menuRenderer(params)
  const scrollBarProps = {
    autoHeight: true,
    autoHeightMin: 0,
    autoHeightMax: 200
  }

  return (
    <Scrollbars {...scrollBarProps}>
      {menu}
    </Scrollbars>
  )
}

const normalizeUnits = units => (
  units.map(unit => ({
    value: unit.id,
    label: `${unit.inep_code} - ${unit.suggested_name || unit.name}`
  }))
)

const fetchOptions = (input, page) => {
  let params = { name: input }
  if (Number.isInteger(parseInt(input, 10))) {
    params = { inep_code: input }
  }
  return request.get('/units/search?with_school_adoptions=true', {
    params: {
      ...params,
      per: 10,
      page
    }
  })
    .then(({ data: units }) => {
      return { options: normalizeUnits(units) }
    })
}

class SelectUnits extends Component {
  state = {
    unit: null
  }

  onChangeUnit = (unit) => (
    this.setState({ unit: this.shortenUnitLabel(unit) }, () => this.props.changeUnit(unit))
  )

  selectProps = {
    placeholder: 'Selecionar Escola',
    className: 'select__unit',
    onChange: this.onChangeUnit,
    menuRenderer: menuRenderer,
    openAfterFocus: true,
    pagination: true
  }

  shortenUnitLabel = unit => {
    if (!isEmpty(unit)) {
      return ({...unit, label: truncate(unit.label)})
    }
  }

  componentDidMount () {
    const { authUserUnits, role } = this.props

    if (role !== 'fractal_operator' && authUserUnits && authUserUnits.length > 0) {
      const unit = normalizeUnits(authUserUnits)[0]

      this.setState({unit: this.shortenUnitLabel(unit)})
      this.props.changeUnit(unit)
    }
  }

  render () {
    const { role, authUserUnits } = this.props

    return role === 'fractal_operator'
      ? <Select.Async {...this.selectProps} value={this.state.unit} loadOptions={fetchOptions} />
      : <Select {...this.selectProps} value={this.state.unit} options={normalizeUnits(authUserUnits)} />
  }
}

export default SelectUnits



// WEBPACK FOOTER //
// ./src/components/Select/SelectUnits.js